import * as PIXI from 'pixi.js';
import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
	"list": [
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9",
			"buttonMode": false,
			"parent": "",
			"name": "root",
			"type": "Container"
		},
		{
			"x": 0,
			"y": -385.20000000000005,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "4edc5ec4-ec5f-472b-bcba-f68205338332",
			"buttonMode": false,
			"parent": "35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9",
			"name": "",
			"type": "Container"
		},
		{
			"x": 0,
			"y": -27,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "946f1593-1de5-4e89-8184-d60ca8733062",
			"buttonMode": false,
			"parent": "4edc5ec4-ec5f-472b-bcba-f68205338332",
			"name": "scoreLabel",
			"type": "Text",
			"text": "Score: %%%",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 56,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 37.80000000000001,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 0.7,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "cbde13f4-fbbd-48be-8578-639863f80eba",
			"buttonMode": false,
			"parent": "4edc5ec4-ec5f-472b-bcba-f68205338332",
			"name": "highscoreText",
			"type": "Text",
			"text": "Highscore: %%%",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 1.7999999999999545,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "8b0e5124-22a6-496e-a274-7a9fa9f2b9cc",
			"buttonMode": false,
			"parent": "35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9",
			"name": "",
			"type": "Container"
		},
		{
			"x": 0,
			"y": -63,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "8db008c0-8bd9-438e-8451-2f4909f9233d",
			"buttonMode": false,
			"parent": "8b0e5124-22a6-496e-a274-7a9fa9f2b9cc",
			"name": "inputField",
			"type": "Container"
		},
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": true,
			"hitArea": {
				"type": "None"
			},
			"id": "ead70ec2-f545-47ef-abb4-6db017e14057",
			"buttonMode": false,
			"parent": "8db008c0-8bd9-438e-8451-2f4909f9233d",
			"name": "inputSprite",
			"type": "Sprite",
			"texture": "Score_Background",
			"tint": 16777215
		},
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "07be360a-e0d9-416a-9763-6c33fa35233e",
			"buttonMode": false,
			"parent": "8db008c0-8bd9-438e-8451-2f4909f9233d",
			"name": "inputLabel",
			"type": "Text",
			"text": "Enter Your Name",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 64.80000000000007,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": true,
			"hitArea": {
				"type": "None"
			},
			"id": "0be548d6-4e5d-4bed-bc2f-d1bde65c6a98",
			"buttonMode": true,
			"parent": "8b0e5124-22a6-496e-a274-7a9fa9f2b9cc",
			"name": "submitButton",
			"type": "Sprite",
			"texture": "Touch_To_Continue_Button",
			"tint": 16777215
		},
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "fbe6e5a4-1451-4f1d-8364-48f864bc4437",
			"buttonMode": false,
			"parent": "0be548d6-4e5d-4bed-bc2f-d1bde65c6a98",
			"name": "",
			"type": "Text",
			"text": "Submit Score",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 387,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "9360991d-accf-47f6-8b02-dfe875261085",
			"buttonMode": false,
			"parent": "35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9",
			"name": "",
			"type": "Container"
		},
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": true,
			"hitArea": {
				"type": "None"
			},
			"id": "132755ad-b0cd-4012-a092-b3b549b74acc",
			"buttonMode": true,
			"parent": "9360991d-accf-47f6-8b02-dfe875261085",
			"name": "continueButton",
			"type": "Sprite",
			"texture": "Touch_To_Continue_Button",
			"tint": 16777215
		},
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"hitArea": {
				"type": "None"
			},
			"id": "35fd2c57-248a-4b24-8d09-975dda5c293f",
			"buttonMode": false,
			"parent": "132755ad-b0cd-4012-a092-b3b549b74acc",
			"name": "",
			"type": "Text",
			"text": "Play Again",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		}
	],
	"x": 50,
	"y": 50,
	"width": 421,
	"height": 647,
	"handleResize": true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
	root: boolean;
	continueButton: boolean;
	scoreLabel: boolean;
	highscoreText: boolean;
	continueLabel: boolean;
}>;

class Layout {
	public readonly root: PIXI.Container;
	public readonly continueButton: PIXI.Sprite;
	public readonly submitButton: PIXI.Sprite;
	public readonly inputField: PIXI.Container;
	public readonly inputSprite: PIXI.Sprite;
	public readonly inputLabel: PIXI.Text;
	public readonly scoreLabel: PIXI.Text;
	public readonly highscoreText: PIXI.Text;

	constructor(filter?: Filter) {
		populate(this, raw, filter);
	}
}

export { Layout, Filter, raw };
